import React from 'react'
import { Container } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav'

function SideBar(props){
    const {setActivePage} = props;
    //const [activeKey, setActiveKey] = React.useState('link-1')
    const handleSelect = (eventKey) =>{
        setActivePage(eventKey)
        console.log(eventKey)
    } 

    return (
        <Container className='navigation-bar'>
            <Nav fill variant="tabs"  onSelect={handleSelect} defaultActiveKey='home' >
            <Nav.Item>
                <Nav.Link eventKey="home">Active</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="calendarView" >Calendar View </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="link-2">Time Usage</Nav.Link>
            </Nav.Item> */}
      
        </Nav>
        </Container>
        
    )
}

export default SideBar;